export default "__VITE_ASSET__3d8ce158__"